import { render, staticRenderFns } from "./MailingView.vue?vue&type=template&id=f105ade2"
import script from "./MailingView.vue?vue&type=script&lang=js"
export * from "./MailingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports